import Vue from "vue";
import LightBootstrap from "./light-bootstrap-main";
import { Loading } from 'element-ui';

import router from "./router";

Vue.use(Loading);
// Plugins
import App from "./App.vue";

import JSONView from "vue-json-component";
Vue.use(JSONView)

// vuex setup
import store from "./store";
import { Scrollbar } from "element-ui";
Vue.component(Scrollbar.name, Scrollbar);
// plugin setup
Vue.use(LightBootstrap);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});
